import React, { useState } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import MediaModal from "../MediaModal/MediaModal";
import { useParams } from "react-router-dom";

const RecipeCarousel = ({ dataRecipes }) => {
  const baseUrl = "https://backrecrez.bbros.al";
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState({});
  const { id } = useParams();

  const openModal = (type, url) => {
    const media = new Image();

    media.onload = function () {
      setSelectedMedia({
        type,
        url,
        width: media.width,
        height: media.height,
      });

      setModalOpen(true);
    };

    media.src = url;
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  const carouselItems = dataRecipes
    .filter((item) => item.id == id)
    .flatMap(
      (item) =>
        item?.video?.map((video, videoIndex) => ({
          type: video.filename.match(/\.(mp4|mov|avi)$/i) ? "video" : "image",
          url: `${baseUrl}/${video.path}`,
        })) || []
    );

  const renderedItems = carouselItems.map((item, index) => (
    <div
      key={index}
      className="carousel-item"
      onClick={() => openModal(item.type, item.url)}
    >
      <div>
        {item.type === "image" && (
          <img
            style={{ width: "500px", height: "300px" }}
            src={item.url}
            alt={`Slide ${index}`}
          />
        )}
        {item.type === "video" && (
          <video className="w-[500px] h-[300px]">
            <source src={item.url} type="video/mp4" />
          </video>
        )}
      </div>
    </div>
  ));

  return (
    <div className="carousel">
      <div className="carousel-container">
        <AliceCarousel
          mouseTracking
          items={renderedItems}
          responsive={{
            0: { items: 1 },
            600: { items: 1 },
            1024: { items: 1 },
          }}
          autoPlay={true}
          autoWidth={800}
          autoPlayInterval={3000}
          animationDuration={500}
          disableButtonsControls
        />
        <MediaModal
          isOpen={modalOpen}
          onClose={closeModal}
          mediaType={selectedMedia.type}
          mediaUrl={selectedMedia.url}
        />
      </div>
    </div>
  );
};

export default RecipeCarousel;
